<template>
  <div id="plan">
    <el-row>
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" @submit.native.prevent @keyup.enter.native="doSelect">
          <el-form-item>
            <el-input placeholder="输入订单号" prefix-icon="el-icon-search" v-model="key.id"></el-input>
          </el-form-item>
          <el-form-item v-if="roles.indexOf('4')>-1">
            <el-checkbox v-model="key.superSearch" style="margin-left: 20px">高级筛选</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSelect" v-if="roles.indexOf('4')>-1">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!-- 高级搜索 -->
    <el-row
      v-if="key.superSearch"
      style="width: 100%; margin-bottom:20px; background-color: #eee; border-radius: 8px;"
    >
      <el-form
        :inline="true"
        style="margin: 20px 10px 0px 20px"
        :gutter="20"
        @submit.native.prevent
      >
        <el-form-item label="下单日期">
          <el-date-picker
            v-model="key.searchTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="订单状态" style="margin-left: 20px">
          <el-select v-model="key.planStatus">
            <el-option label="延迟交货" value="0"></el-option>
            <el-option label="正常交货" value="1"></el-option>
            <el-option label="未计划" value="2"></el-option>
            <el-option label="无" value></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="key.overTime" style="margin-left: 20px">计划交货时间已过</el-checkbox>
        </el-form-item>
      </el-form>
    </el-row>
    <div>
      <i class="over-time">红色</i>为延期交货,
      <i class="no-plan">绿色</i>为未计划
    </div>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="float:left;"
      ></el-pagination>
    </el-col>

    <!-- 列表 -->
    <el-table
      :data="infos"
      border
      style="width: 100%;"
      v-loading="listLoading"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="order" label="订单号" width="148px"></el-table-column>
      <el-table-column prop="status" label="订单状态" width="128px"></el-table-column>
      <el-table-column prop="createTime" label="下单日期" width="100px"></el-table-column>
      <el-table-column prop="deliveryTime" label="交货日期" width="100px"></el-table-column>
      <el-table-column prop="planTime" label="计划日期" width="100px"></el-table-column>
      <el-table-column prop="material" label="材料"></el-table-column>
      <el-table-column prop="style" label="规格"></el-table-column>
      <el-table-column prop="quantity" label="数量(卷)" width="60px"></el-table-column>
      <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
  </div>
</template> 

<script>
export default {
  data: function() {
    return {
      postApi: {
        crud: "",
        info: {}
      },

      key: {
        id: "",
        superSearch: false,
        searchTime: "",
        overTime: false,
        planStatus: ""
      },

      page: 1, //分页显示信息
      total: 0,
      pageSize: 10,
      infos: [],
      pageSizes: [10, 20, 30, 40],

      message: {
        result: {
          infos: []
        }
      }
    };
  },
  created: function() {
    this.doSelect();
  },
  methods: {
    //查询
    doSelect: async function() {
      this.postApi.crud = "r";
      this.postApi.info = {
        key: this.key
      };
      this.listLoading = true;
      this.message = await this.$doPost("/api/report/plan", this.postApi);
      // console.log(this.message.result)
      if (this.message.msgCode == 0) {
        this.total = this.message.result.infos.length;
        this.getPageInfo();
      } else {
        this.$message.error(this.message.msg);
      }
      this.listLoading = false;
    },
    tableRowClassName(val) {
      if (val.row.planTime == "") {
        return "no-plan";
      } else {
        var date1 = new Date(val.row.deliveryTime.replace(/-/g, "/"));
        var date2 = new Date(val.row.planTime.replace(/-/g, "/"));
        if (date1 < date2) {
          return "over-time";
        } else {
          return "";
        }
      }
    },
    //分页
    handleCurrentChange(val) {
      this.page = val;
      this.getPageInfo();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPageInfo();
    },
    getPageInfo() {
      this.infos = [];
      for (
        let i = this.pageSize * (this.page - 1);
        i < this.pageSize * this.page;
        i++
      ) {
        if (i == this.message.result.infos.length) break;
        this.infos.push(this.message.result.infos[i]);
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>

<style scope>
.no-plan {
  background: #90ee90 !important;
  /* color: white !important; */
}

.over-time {
  background: #ffaeb9 !important;
  /* color: white !important; */
}
</style>




// WEBPACK FOOTER //
// src/components/report/plan.vue